import React from 'react';
import PropTypes from 'prop-types';
import { SimpleTableComponent } from '../../../../../../../components/simple-table';
import { TABLE_COLUMNS_NAMES } from '../../../../constants';
import { CustomLoader } from '../../../../../../../components/custom-loader';

const CompanyAboutContent = ({ companyAboutInfo, isCompanyInfoLoading }) => {
	if (isCompanyInfoLoading) {
		return <CustomLoader />;
	}

	return (
		<div>
			<SimpleTableComponent
				rows={companyAboutInfo}
				isTableDataLoading={isCompanyInfoLoading}
				columns={TABLE_COLUMNS_NAMES}
			/>
		</div>
	);
};

CompanyAboutContent.propTypes = {
	companyAboutInfo: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	isCompanyInfoLoading: PropTypes.bool.isRequired,
};

export default CompanyAboutContent;
